import React from 'react';
export default function ScreenRenderer({ layout, fields }) {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center text-sm text-gray-400">
      Screen Preview — {(layout?.widgets || []).length} widget(s) configured.
      Open the tenant app to see the full live preview.
    </div>
  );
}
